import React from 'react';
import loadable from '@loadable/component';

export const AsyncEnquiryLayout = loadable(() => import(/* webpackPrefetch: true */ './EnquiryLayout'));

const Enquiry = (props) => <AsyncEnquiryLayout {...props} />;

export default Enquiry;
